function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "signout-icon");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M497,209,329,377c-15,15-41,4.5-41-17V264H152a23.94,23.94,0,0,1-24-24V144a23.94,23.94,0,0,1,24-24H288V24c0-21.4,25.9-32,41-17L497,175A24.2,24.2,0,0,1,497,209ZM192,372V332a12,12,0,0,0-12-12H96a32,32,0,0,1-32-32V96A32,32,0,0,1,96,64h84a12,12,0,0,0,12-12V12A12,12,0,0,0,180,0H96A96,96,0,0,0,0,96V288a96,96,0,0,0,96,96h84A12,12,0,0,0,192,372Z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503.97,
    height: 384.06,
    viewBox: "0 0 503.97 384.06"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/logout-icon.50f938a3.svg";
export { SvgComponent as ReactComponent };